import ApartmentDetails from './ApartmentDetails';

export default ApartmentDetails;
